'use client'
import { storyblokEditable } from '@storyblok/react'
import { Badge } from 'ui/src/components/Badge/Badge'
import { Text } from 'ui/src/components/Text/Text'
import * as GridLayout from '@/components/GridLayout/GridLayout'
import { type SbBaseBlockProps, type ExpectedBlockType, type GridColumnsField } from '@/services/storyblok/storyblok'
import { filterByBlockType } from '@/services/storyblok/Storyblok.helpers'
import { list, listItem } from './USPBlock.css'

type USPBlockProps = SbBaseBlockProps<{
  items: ExpectedBlockType<USPItemBlockProps>
  layout?: GridColumnsField
}>

export function USPBlock({ blok }: USPBlockProps) {
  const uspItems = filterByBlockType(blok.items, USPBlockItem.blockName)

  return (
    <GridLayout.Root {...storyblokEditable(blok)}>
      <GridLayout.Content width={blok.layout?.widths ?? '1'} align={blok.layout?.alignment ?? 'center'}>
        <ul className={list}>
          {uspItems.map((nestedBlock) => (
            <USPBlockItem key={nestedBlock._uid} blok={nestedBlock} numberOfItems={uspItems.length} />
          ))}
        </ul>
      </GridLayout.Content>
    </GridLayout.Root>
  )
}
USPBlock.blockName = 'usp'

type USPItemBlockProps = SbBaseBlockProps<{
  title: string
  content: string
}> & { numberOfItems: number }

export function USPBlockItem({ blok, numberOfItems }: USPItemBlockProps) {
  return (
    <li className={listItem} style={{ maxWidth: numberOfItems >= 3 ? '28.125rem' : '40.625rem' }}>
      <Badge as="h3">{blok.title}</Badge>
      <Text size={{ _: 'xl' }}>{blok.content}</Text>
    </li>
  )
}
USPBlockItem.blockName = 'uspItem'
